import { createFileRoute } from "@tanstack/react-router";
import { ProjectDetailPage } from "@charphq/ui/components/layout/pages/ProjectDetailPage";

export const Route = createFileRoute("/projects_/$projectId")({
  component: ProjectDetailComponent,
});

function ProjectDetailComponent() {
  const { projectId } = Route.useParams();
  return <ProjectDetailPage projectId={projectId} />;
}
